import { HttpClient } from '@angular/common/http'

export interface IBaseRepository {
    setToDto(dto: (target: any) => any): IBaseRepository
}

export abstract class BaseRepository implements IBaseRepository {
    constructor(
        protected http: HttpClient,
        controllerName: string,
    ) {
        this.url = 'api/' + controllerName
    }

    protected _toDto!: (target: any) => any
    public url: string

    protected toDto(item: any): any {
        if (this._toDto) return this._toDto(item)
        return item
    }

    public setToDto(dto: (target: any) => any): IBaseRepository {
        this._toDto = dto
        return this
    }
}
